var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"i"},[_c('img',{attrs:{"src":_vm.imagens['subImg' + _vm.sub ],"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }